<span class="title">Rentrez l'adresse e-mail de l'utilisateur à ajouter</span>
<input [(ngModel)]="email" />
<app-button text="Valider" (onClick)="createNewSubscriber(email)" [disabled]="!email || loading"></app-button>
